/**
 * Pick the LiveKit instance that owns a device. Prefer one that already has
 * tracks; if T7 local-mode deny unsubscribed cloud maps (and local prestart
 * hid #videoCloud), still return the mode-matched instance so attach/HIL can
 * find the room. CI #1509 357cd52201 bandwidth-governor never attached.
 *
 * Kept out of utils.ts so Jest can import it without the LiveKit broker graph
 * (zustand/traditional). Per rule: reference-rules-in-comments (ai.knowledge/global).
 */
export function selectLiveKitIdForDevice<Id>(
  candidates: Array<{ id: Id; mode: 'cloud' | 'local'; hasTrack: boolean }>,
  wantedMode: 'cloud' | 'local'
): Id | undefined {
  const matching = candidates.filter((candidate) => candidate.mode === wantedMode);
  return matching.find((candidate) => candidate.hasTrack)?.id ?? matching[0]?.id;
}
